function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (t, e) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = e(require("jquery")) : "function" == typeof define && define.amd ? define(["jquery"], e) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports["@tomasc/simple_form_markdown_editor"] = e(require("jquery")) : t["@tomasc/simple_form_markdown_editor"] = e(t.jquery);
}(window, function (t) {
  return function (t) {
    var e = {};

    function i(s) {
      if (e[s]) return e[s].exports;
      var n = e[s] = {
        i: s,
        l: !1,
        exports: {}
      };
      return t[s].call(n.exports, n, n.exports, i), n.l = !0, n.exports;
    }

    return i.m = t, i.c = e, i.d = function (t, e, s) {
      i.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: s
      });
    }, i.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, i.t = function (t, e) {
      if (1 & e && (t = i(t)), 8 & e) return t;
      if (4 & e && "object" == _typeof(t) && t && t.__esModule) return t;
      var s = Object.create(null);
      if (i.r(s), Object.defineProperty(s, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var n in t) {
        i.d(s, n, function (e) {
          return t[e];
        }.bind(null, n));
      }
      return s;
    }, i.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t["default"];
      } : function () {
        return t;
      };
      return i.d(e, "a", e), e;
    }, i.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, i.p = "", i(i.s = 8);
  }([function (t, e, i) {
    "use strict";

    (function (t) {
      e.a =
      /*#__PURE__*/
      function () {
        _createClass(_class, null, [{
          key: "register",
          value: function register() {
            var t, e, i, s;
            return this, e = (t = null != (i = this.defaults) ? i : {}).name || (t.name = /function ([^(]*)/.exec(this + "")[1]), Array.prototype.slice.call(arguments).slice(1), null != (s = arguments[0]) ? s : this.selector, this.init_plugin(this, e);
          }
        }, {
          key: "init_plugin",
          value: function init_plugin(e, i) {
            if (void 0 === t.fn[i]) return t.fn[i] = function (t) {
              var s, n, r;
              return s = arguments, n = "plugin_".concat(i), void 0 === t || "object" == _typeof(t) ? this.each(function () {
                var i;
                if (this.pluginInstances || (this.pluginInstances = {}), !this.pluginInstances[n]) return i = new e(this, t), this.pluginInstances[n] = i;
              }) : "string" == typeof t && "_" !== t[0] && "init" !== t ? (r = void 0, this.each(function () {
                var i;
                if (this.pluginInstances || (this.pluginInstances = {}), (i = this.pluginInstances[n]) instanceof e && "function" == typeof i[t] && (r = i[t].apply(i, Array.prototype.slice.call(s, 1))), "destroy" === t) return this.pluginInstances[n] = null;
              }), void 0 !== r ? r : this) : void 0;
            };
          }
        }]);

        function _class(e, i) {
          _classCallCheck(this, _class);

          this.element = e, this.options = t.extend({}, this.constructor.defaults, i), this.$element = t(this.element), this.init();
        }

        return _class;
      }();
    }).call(this, i(1));
  }, function (e, i) {
    e.exports = t;
  }, function (t, e, i) {
    "use strict";

    (function (t) {
      var s = i(0),
          n = i(3),
          r = i(4),
          o = i(5),
          _ = i(6),
          a = i(7);

      e.a = function () {
        var e =
        /*#__PURE__*/
        function (_s$a) {
          _inherits(e, _s$a);

          function e() {
            _classCallCheck(this, e);

            return _possibleConstructorReturn(this, _getPrototypeOf(e).apply(this, arguments));
          }

          _createClass(e, [{
            key: "init",
            value: function init() {
              var _this = this;

              return this.Buttons = new n.a(this.get_buttons()[0]), this.Editor = new r.a(this.get_editor()[0]), this.Help = new o.a(this.get_help()[0]), this.Preview = new _.a(this.get_preview()[0]), this.Tabs = new a.a(this.get_tabs()[0]), this.$element.on("show_editor.SimpleFormMarkdownEditor", function (t) {
                return t.stopPropagation(), _this.$element.addClass(_this.options.is_editor_class);
              }), this.$element.on("show_preview.SimpleFormMarkdownEditor", function (t) {
                return t.stopPropagation(), _this.$element.removeClass(_this.options.is_editor_class);
              }), this.$element.on("show_preview.SimpleFormMarkdownEditor", function (e) {
                var i, s;
                return e.stopPropagation(), i = _this.get_options(), s = _this.Editor.get_val(), t.ajax({
                  type: "POST",
                  url: _this.get_preview_path(),
                  data: {
                    _method: "PUT",
                    text: s,
                    options: i
                  },
                  success: function success(t) {
                    return _this.get_preview().trigger({
                      type: "show_preview",
                      html: t
                    });
                  }
                });
              }), this.$element.on("toggle_help.SimpleFormMarkdownEditor", function (t) {
                return t.stopPropagation(), _this.$element.toggleClass(_this.options.is_help_class);
              }), this.$element.on("execute_command.SimpleFormMarkdownEditor", function (t) {
                var e, i;
                return t.stopPropagation(), e = t.command, i = _this.options.definitions[e], _this.get_editor().trigger({
                  type: "execute_command_definition",
                  command: e,
                  definition: i
                });
              });
            }
          }, {
            key: "destroy",
            value: function destroy() {
              return this.Buttons && this.Buttons.destroy(), this.Editor && this.Editor.destroy(), this.Help && this.Help.destroy(), this.Preview && this.Preview.destroy(), this.Tabs && this.Tabs.destroy(), this.$element.off(".SimpleFormMarkdownEditor");
            }
          }, {
            key: "get_buttons",
            value: function get_buttons() {
              return this.$element.find(".simple_form_markdown_editor__buttons");
            }
          }, {
            key: "get_editor",
            value: function get_editor() {
              return this.$element.find(".simple_form_markdown_editor__editor");
            }
          }, {
            key: "get_help",
            value: function get_help() {
              return this.$element.find(".simple_form_markdown_editor__help");
            }
          }, {
            key: "get_preview",
            value: function get_preview() {
              return this.$element.find(".simple_form_markdown_editor__preview");
            }
          }, {
            key: "get_tabs",
            value: function get_tabs() {
              return this.$element.find(".simple_form_markdown_editor__tabs");
            }
          }, {
            key: "get_options",
            value: function get_options() {
              return this.$element.data("options");
            }
          }, {
            key: "get_preview_path",
            value: function get_preview_path() {
              return this.$element.data("preview-path");
            }
          }]);

          return e;
        }(s.a);

        return e.defaults = {
          debug: !1,
          name: "simple_form_markdown_editor",
          definitions: {
            strong: "**%{str}**",
            em: "*%{str}*",
            code: "`%{str}`",
            hr: "%{str}***",
            ul: "* %{str}",
            ol: "1. %{str}",
            blockquote: "> %{str}",
            h1: "# %{str}",
            h2: "## %{str}",
            h3: "### %{str}",
            h4: "#### %{str}",
            h5: "##### %{str}",
            h6: "###### %{str}",
            a: "[%{str}](|)",
            img: "![%{str}](|)"
          },
          is_editor_class: "simple_form_markdown_editor__is_editor",
          is_help_class: "simple_form_markdown_editor__is_help"
        }, e;
      }();
    }).call(this, i(1));
  }, function (t, e, i) {
    "use strict";

    (function (t) {
      var s = i(0);

      e.a = function () {
        var e =
        /*#__PURE__*/
        function (_s$a2) {
          _inherits(e, _s$a2);

          function e() {
            _classCallCheck(this, e);

            return _possibleConstructorReturn(this, _getPrototypeOf(e).apply(this, arguments));
          }

          _createClass(e, [{
            key: "init",
            value: function init() {
              var _this2 = this;

              return this.$element.on("click.SimpleFormMarkdownEditor__Buttons", '.simple_form_markdown_editor__button[value="help"]', function (t) {
                return _this2.$element.trigger("toggle_help");
              }), this.$element.on("click.SimpleFormMarkdownEditor__Buttons", '.simple_form_markdown_editor__button:not([value="help"])', function (e) {
                var i;
                return i = t(e.target).attr("value"), _this2.$element.trigger({
                  type: "execute_command",
                  command: i
                });
              });
            }
          }, {
            key: "destroy",
            value: function destroy() {
              return this.$element.off(".SimpleFormMarkdownEditor__Buttons");
            }
          }]);

          return e;
        }(s.a);

        return e.defaults = {
          debug: !1,
          name: "simple_form_markdown_editor__buttons"
        }, e;
      }();
    }).call(this, i(1));
  }, function (t, e, i) {
    "use strict";

    var s = i(0);

    e.a = function () {
      var t =
      /*#__PURE__*/
      function (_s$a3) {
        _inherits(t, _s$a3);

        function t() {
          _classCallCheck(this, t);

          return _possibleConstructorReturn(this, _getPrototypeOf(t).apply(this, arguments));
        }

        _createClass(t, [{
          key: "init",
          value: function init() {
            var _this3 = this;

            return this.$element.on("execute_command_definition.SimpleFormMarkdownEditor__Editor", function (t) {
              var e, i;
              return t.stopPropagation(), e = t.command, i = t.definition, _this3.execute_command_definition(e, i);
            });
          }
        }, {
          key: "destroy",
          value: function destroy() {
            return this.$element.off(".SimpleFormMarkdownEditor__Editor");
          }
        }, {
          key: "get_textarea",
          value: function get_textarea() {
            return this.$element.find("textarea");
          }
        }, {
          key: "get_val",
          value: function get_val() {
            return this.get_textarea().val();
          }
        }, {
          key: "get_selection",
          value: function get_selection() {
            var t;
            return {
              start: (t = this.get_textarea())[0].selectionStart,
              end: t[0].selectionEnd,
              length: t[0].selectionEnd - t[0].selectionStart,
              text: t.val().substring(t[0].selectionStart, t[0].selectionEnd)
            };
          }
        }, {
          key: "execute_command_definition",
          value: function execute_command_definition(t, e) {
            var i, s, n, r, o;
            return r = this.get_selection(), i = (n = e.replace("%{str}", r.text)).indexOf("|"), o = r.start, s = r.start + n.length, i > -1 && (n = n.replace(/\|/g, ""), o = r.start + i, s = r.start + i), this.replace_selection(n), this.set_selection(o, s);
          }
        }, {
          key: "set_selection",
          value: function set_selection(t, e) {
            var i;
            return (i = this.get_textarea()).focus(), i[0].selectionStart = t, i[0].selectionEnd = e;
          }
        }, {
          key: "replace_selection",
          value: function replace_selection(t) {
            var e, i, s, n;
            return s = (e = this.get_textarea())[0].selectionStart, i = e[0].selectionEnd, n = e.val(), e.val(n.substring(0, s) + t + n.substring(i, n.length));
          }
        }]);

        return t;
      }(s.a);

      return t.defaults = {
        name: "simple_form_markdown_editor__editor",
        debug: !1
      }, t;
    }();
  }, function (t, e, i) {
    "use strict";

    (function (t) {
      var s = i(0);

      e.a = function () {
        var e =
        /*#__PURE__*/
        function (_s$a4) {
          _inherits(e, _s$a4);

          function e() {
            _classCallCheck(this, e);

            return _possibleConstructorReturn(this, _getPrototypeOf(e).apply(this, arguments));
          }

          _createClass(e, [{
            key: "init",
            value: function init() {
              var _this4 = this;

              var e;
              return e = this.get_sections().first(), this.set_section(e), this.$element.on("click.SimpleFormMarkdownEditor__Help", ".simple_form_markdown_editor__help__section", function (e) {
                return e.preventDefault(), _this4.set_section(t(e.currentTarget));
              }), this.$element.on("click.SimpleFormMarkdownEditor__Help", ".simple_form_markdown_editor__help__sub_section__item", function (e) {
                return e.preventDefault(), _this4.set_sub_section_item(t(e.currentTarget));
              });
            }
          }, {
            key: "destroy",
            value: function destroy() {
              return this.$element.off(".SimpleFormMarkdownEditor__Help");
            }
          }, {
            key: "get_help_text",
            value: function get_help_text(t) {
              return this.get_help_texts().filter("[data-sub-section='".concat(t, "']"));
            }
          }, {
            key: "get_help_texts",
            value: function get_help_texts() {
              return this.$element.find(".simple_form_markdown_editor__help__text");
            }
          }, {
            key: "get_sections",
            value: function get_sections() {
              return this.$element.find(".simple_form_markdown_editor__help__section");
            }
          }, {
            key: "get_sub_section",
            value: function get_sub_section(t) {
              return this.get_sub_sections().filter("[data-section='".concat(t, "']"));
            }
          }, {
            key: "get_sub_section_items",
            value: function get_sub_section_items() {
              return this.$element.find(".simple_form_markdown_editor__help__sub_section__item");
            }
          }, {
            key: "get_sub_sections",
            value: function get_sub_sections() {
              return this.$element.find(".simple_form_markdown_editor__help__sub_section");
            }
          }, {
            key: "set_section",
            value: function set_section(t) {
              var e, i;
              return t.siblings().removeClass(this.options.section_is_active_class), t.addClass(this.options.section_is_active_class), i = t.data("section"), e = this.get_sub_section(i), this.set_sub_section(e);
            }
          }, {
            key: "set_sub_section",
            value: function set_sub_section(t) {
              var e;
              return t.siblings().removeClass(this.options.sub_section_is_active_class), t.addClass(this.options.sub_section_is_active_class), e = t.find(".simple_form_markdown_editor__help__sub_section__item").first(), this.set_sub_section_item(e);
            }
          }, {
            key: "set_sub_section_item",
            value: function set_sub_section_item(t) {
              var e, i;
              return t.siblings().removeClass(this.options.sub_section_item_is_active_class), t.addClass(this.options.sub_section_item_is_active_class), i = t.data("sub-section"), e = this.get_help_text(i), this.set_help_text(e);
            }
          }, {
            key: "set_help_text",
            value: function set_help_text(t) {
              return t.siblings().removeClass(this.options.help_text_is_active_class), t.addClass(this.options.help_text_is_active_class);
            }
          }]);

          return e;
        }(s.a);

        return e.defaults = {
          name: "simple_form_markdown_editor__help",
          debug: !1,
          section_is_active_class: "simple_form_markdown_editor__help__section__is_active",
          sub_section_is_active_class: "simple_form_markdown_editor__help__sub_section__is_active",
          sub_section_item_is_active_class: "simple_form_markdown_editor__help__sub_section__item__is_active",
          help_text_is_active_class: "simple_form_markdown_editor__help__text__is_active"
        }, e;
      }();
    }).call(this, i(1));
  }, function (t, e, i) {
    "use strict";

    var s = i(0);

    e.a = function () {
      var t =
      /*#__PURE__*/
      function (_s$a5) {
        _inherits(t, _s$a5);

        function t() {
          _classCallCheck(this, t);

          return _possibleConstructorReturn(this, _getPrototypeOf(t).apply(this, arguments));
        }

        _createClass(t, [{
          key: "init",
          value: function init() {
            var _this5 = this;

            return this.$element.on("show_preview.SimpleFormMarkdownEditor__Preview", function (t) {
              var e;
              return t.stopPropagation(), e = t.html || "<p>" + _this5.get_nothing_to_preview_text() + "</p>", _this5.$element.html(e);
            });
          }
        }, {
          key: "destroy",
          value: function destroy() {
            return this.$element.off(".SimpleFormMarkdownEditor__Preview");
          }
        }, {
          key: "get_nothing_to_preview_text",
          value: function get_nothing_to_preview_text() {
            return this.$element.data("nothing-to-preview-text") || "Nothing to preview.";
          }
        }]);

        return t;
      }(s.a);

      return t.defaults = {
        name: "simple_form_markdown_editor__preview",
        debug: !1
      }, t;
    }();
  }, function (t, e, i) {
    "use strict";

    (function (t) {
      var s = i(0);

      e.a = function () {
        var e =
        /*#__PURE__*/
        function (_s$a6) {
          _inherits(e, _s$a6);

          function e() {
            _classCallCheck(this, e);

            return _possibleConstructorReturn(this, _getPrototypeOf(e).apply(this, arguments));
          }

          _createClass(e, [{
            key: "init",
            value: function init() {
              var _this6 = this;

              return this.set_active_tab(this.get_edit_tab()), this.$element.on("click.SimpleFormMarkdownEditor__Tabs", ".simple_form_markdown_editor__tab", function (e) {
                return _this6.set_active_tab(t(e.currentTarget));
              }), this.$element.on("click.SimpleFormMarkdownEditor__Tabs", ".simple_form_markdown_editor__tab__edit", function (t) {
                return _this6.$element.trigger("show_editor");
              }), this.$element.on("click.SimpleFormMarkdownEditor__Tabs", ".simple_form_markdown_editor__tab__preview", function (t) {
                return _this6.$element.trigger("show_preview");
              });
            }
          }, {
            key: "destroy",
            value: function destroy() {
              return this.$element.off(".SimpleFormMarkdownEditor__Tabs");
            }
          }, {
            key: "get_edit_tab",
            value: function get_edit_tab() {
              return this.$element.find(".simple_form_markdown_editor__tab__edit");
            }
          }, {
            key: "get_preview_tab",
            value: function get_preview_tab() {
              return this.$element.find(".simple_form_markdown_editor__tab__preview");
            }
          }, {
            key: "get_tabs",
            value: function get_tabs() {
              return this.$element.find(".simple_form_markdown_editor__tab");
            }
          }, {
            key: "set_active_tab",
            value: function set_active_tab(t) {
              return this.get_tabs().removeClass(this.options.is_active_class), t.addClass(this.options.is_active_class);
            }
          }]);

          return e;
        }(s.a);

        return e.defaults = {
          name: "simple_form_markdown_editor__tabs",
          debug: !1,
          is_active_class: "simple_form_markdown_editor__tab__is_active"
        }, e;
      }();
    }).call(this, i(1));
  }, function (t, e, i) {
    "use strict";

    i.r(e);
    i(9), i(10), i(11), i(12), i(13), i(14), i(15), i(16), i(17), i(18), i(19), i(20), i(21), i(22), i(23), i(24), i(25), i(26), i(27);
    var s = i(2);
    e["default"] = s.a;
  }, function (t, e, i) {}, function (t, e, i) {}, function (t, e, i) {}, function (t, e, i) {}, function (t, e, i) {}, function (t, e, i) {}, function (t, e, i) {}, function (t, e, i) {}, function (t, e, i) {}, function (t, e, i) {}, function (t, e, i) {}, function (t, e, i) {}, function (t, e, i) {}, function (t, e, i) {}, function (t, e, i) {}, function (t, e, i) {}, function (t, e, i) {}, function (t, e, i) {}, function (t, e, i) {}]);
});